/**
 * ButtonSettings - настройки одной кнопки
 */
import React from 'react';
import Icon from '../../../components/AppIcon';
import LinkPicker from '../../../components/ui/LinkPicker';
import TextSettings from './TextSettings';

// Варианты кнопок для выбора
const buttonVariants = [
  { value: 'primary', label: 'Основная' },
  { value: 'outline', label: 'Контурная' },
  { value: 'secondary', label: 'Вторичная' },
  { value: 'ghost', label: 'Прозрачная' },
];

// Хелпер для работы с текстовыми данными
const getTextData = (value) => {
  if (typeof value === 'object' && value !== null) return value;
  return { text: value || '' };
};

export default function ButtonSettings({
  button,
  onChange,
  onRemove,
  index,
  allSections = [],
  allPages = [],
  showVariants = true,
  variants = ['primary', 'outline'], // какие варианты показывать
}) {
  const updateField = (field, value) => {
    onChange({ ...button, [field]: value });
  };

  const availableVariants = buttonVariants.filter(v => variants.includes(v.value));

  return (
    <div className="p-3 bg-muted rounded-lg space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">Кнопка {index + 1}</span>
        {onRemove && (
          <button
            onClick={onRemove}
            className="p-1 text-text-secondary hover:text-error transition-colors"
            title="Удалить кнопку"
          >
            <Icon name="Trash2" size={16} />
          </button>
        )}
      </div>

      <TextSettings
        label="Текст"
        value={getTextData(button?.text)}
        onChange={(value) => updateField('text', value)}
        placeholder="Текст кнопки"
        showMultiline={false}
        defaults={{ size: 'base', weight: 'medium', color: 'inherit' }}
      />

      <LinkPicker
        label="Ссылка"
        value={button?.link || ''}
        onChange={(value) => updateField('link', value)}
        pages={allPages}
        sections={allSections}
        placeholder="Выберите ссылку"
      />

      {showVariants && availableVariants.length > 1 && (
        <div>
          <label className="block text-sm font-medium mb-1">Стиль</label>
          <div className="flex gap-2">
            {availableVariants.map((variant) => (
              <button
                key={variant.value}
                onClick={() => updateField('variant', variant.value)}
                className={`flex-1 py-1.5 px-3 rounded text-sm transition-colors ${
                  button?.variant === variant.value
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-background border border-border hover:border-primary/50'
                }`}
              >
                {variant.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
